export function getRenderProfile() {
  const memory = navigator.deviceMemory || 4;
  const cores = navigator.hardwareConcurrency || 4;
  const coarsePointer = matchMedia("(pointer: coarse)").matches;
  const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reducedMotion) {
    return {
      name: "reduced",
      density: 0.42,
      dpr: Math.min(window.devicePixelRatio || 1, 1.25),
      trails: 2,
      reducedMotion: true,
    };
  }

  if (coarsePointer || memory <= 4 || cores <= 4) {
    return {
      name: "mobile",
      density: 0.62,
      dpr: Math.min(window.devicePixelRatio || 1, 1.5),
      trails: 3,
      reducedMotion: false,
    };
  }

  return {
    name: "desktop",
    density: 1,
    dpr: Math.min(window.devicePixelRatio || 1, 2),
    trails: 5,
    reducedMotion: false,
  };
}
